import { lazySanityClient } from 'services/server/sanity/lazyClient';

const client = lazySanityClient();

export default client;
